import React from 'react';

import { LoadingProgressParent, LoadingProgressParentShape } from './loading-progress-provider';

export interface Props {
    loading?: boolean;
    block?: boolean;
}

class LoadingProgress extends React.PureComponent<Props> {
    static contextTypes = {
        loadingProgressParent: LoadingProgressParentShape,
    };

    static defaultProps = {
        loading: false,
        block: true,
    };

    context!: { loadingProgressParent: LoadingProgressParent };

    componentDidMount() {
        if (this.props.loading) {
            this.context.loadingProgressParent.increment(this, this.props.block);
        }
    }

    componentWillUnmount() {
        this.context.loadingProgressParent.decrement(this);
    }

    componentDidUpdate(previousProps: Props) {
        if (!previousProps.loading && this.props.loading) {
            this.context.loadingProgressParent.increment(this, this.props.block);
        } else if (previousProps.loading && !this.props.loading) {
            this.context.loadingProgressParent.decrement(this);
        }
    }

    render() {
        return this.props.children || null;
    }
}

export default LoadingProgress;
